import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungGelsenkirchen() {
  return (
    <CityPageTemplate
      city="Gelsenkirchen"
      slug="gelsenkirchen"
      intro="Gelsenkirchen im Wandel – nutze staatliche Förderungen und smarte Geldanlage für Deine Zukunft."
      description="Unabhängige & digitale Finanzberatung für Gelsenkirchen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
